// extracted by mini-css-extract-plugin
export default {"daysInWeek":"days-in-week_daysInWeek__zkBW5"};